import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';

interface IGetAccountUrlProps {
  customerId: string;
  accountId: string;
}

export interface IFetchAccountDataProps extends IGetAccountUrlProps {
  ccToken: string;
}

function getAccountUrl({
  customerId,
  accountId,
}: IGetAccountUrlProps) {
  return `${getOdataRootUrl()}/ODataApi/Campaign/V2/Customers(${customerId})/Accounts(${accountId})`;
}

export function fetchAccountData({
  accountId,
  customerId,
  ccToken,
}: IFetchAccountDataProps) {
  const url = getAccountUrl({ customerId, accountId });

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
  } as AxiosRequestConfig);
}
